<template>
  <ul v-bind="context.attributes" class="image-switch-list">
    <li
      v-for="(option, index) in context.options"
      :key="index"
      :class="{ active: isEqual(context.model, option.value) }"
    >
      <div @click="context.model = option.value">
        <div style="position: relative">
          <img :src="`${$options.CDN_URL}/100/${option.image}`" />
          <font-awesome-icon
            v-if="isEqual(context.model, option.value)"
            :icon="isLoading ? 'spinner' : 'check-square'"
            :style="{ color: isLoading ? '#999' : '#ff9100' }"
            :class="{ 'fa-spin': isLoading }"
          />
          <div class="img-title">
            {{ option.title }}
          </div>
        </div>
      </div>
    </li>
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
  </ul>
</template>
<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      default() {
        return []
      }
    },
    showTitle: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    ...mapGetters(['imageLoadings']),
    isLoading() {
      const {
        imageLoadings,
        context: { model }
      } = this
      return get(imageLoadings, get(model, 'key'), false)
    }
  },
  methods: {
    isEqual(model, option) {
      return (
        model === option ||
        get(model, 'id', 1) === get(option, 'id', 2) ||
        get(model, 'key', 1) === get(option, 'key', 2)
      )
    }
  }
}
</script>
<style scoped>
ul.image-switch-list {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0px 10px;
  grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
}
ul.image-switch-list li {
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}
ul.image-switch-list li .img-title {
  display: none;
}
ul.image-switch-list li:hover .img-title {
  display: block;
}
ul.image-switch-list li img {
  width: 100%;
  height: 64px;
  object-fit: contain;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px;
  border-radius: 3px;
}
ul.image-switch-list li svg {
  position: absolute;
  bottom: 2px;
  right: 3px;
}
ul.image-switch-list li.placeholder {
  margin-bottom: 0;
  height: 0;
}
div.img-title {
  font-size: 12px;
  text-align: center;
  line-height: 1.2;
  padding: 5px 10px 8px;
  position: absolute;
  background: #404040;
  color: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateY(calc(-100% - 5px)) translateX(-50%);
  border-radius: 4px;
  width: fit-content;
  transition: opacity 0.3s ease;
  -webkit-transition: opacity 0.3s ease;
}
div.img-title:after {
  position: absolute;
  content: '';
  width: 10px;
  height: 10px;
  display: block;
  background: #404040;
  left: 50%;
  transform: rotate(45deg) translateX(-4px);
  bottom: -5px;
}
div.img-title {
}
@keyframes cssAnimation {
  to {
    opacity: 0;
  }
}
@-webkit-keyframes cssAnimation {
  to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageSwitch.vue